import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { s as i, f as r, c as p } from "../../chunks/vec2.js";
import { a } from "../../chunks/vec2f64.js";
import { addPadding as d } from "./viewpointUtils.js";
import n from "./ViewState.js";

var c = /*#__PURE__*/function (_e) {
  _inherits(c, _e);

  var _super = _createSuper(c);

  function c() {
    var _this;

    _classCallCheck(this, c);

    _this = _super.apply(this, arguments), _this.left = 0, _this.top = 0, _this.right = 0, _this.bottom = 0;
    return _this;
  }

  return c;
}(e);

t([s()], c.prototype, "left", void 0), t([s()], c.prototype, "top", void 0), t([s()], c.prototype, "right", void 0), t([s()], c.prototype, "bottom", void 0), c = t([o("esri.views.2d.PaddedViewState.Padding")], c);

var h = /*#__PURE__*/function (_n) {
  _inherits(h, _n);

  var _super2 = _createSuper(h);

  function h() {
    var _this2;

    _classCallCheck(this, h);

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(t)), _this2.paddedViewState = new n(), _this2._updateContent = function () {
      var t = a();
      return function () {
        var e = _this2._get("size"),
            s = _this2._get("padding");

        if (!e || !s) return;
        var o = _this2.paddedViewState;
        i(t, s.left + s.right, s.top + s.bottom), r(t, e, t), p(o.size, t);
        var a = o.viewpoint;
        a && (_this2.viewpoint = a);
      };
    }(), _this2.watch(["size", "padding"], _this2._updateContent, !0), _this2.padding = new c(), _this2.size = [0, 0];
    return _this2;
  }

  _createClass(h, [{
    key: "padding",
    set: function set(t) {
      this._set("padding", t || new c());
    }
  }, {
    key: "viewpoint",
    set: function set(t) {
      if (t) {
        var _e2 = t.clone();

        this.paddedViewState.viewpoint = t, d(_e2, t, this._get("size"), this._get("padding"));
        var _s = this._viewpoint2D,
            _o = _e2.targetGeometry;
        _s.center[0] = _o.x, _s.center[1] = _o.y, _s.rotation = _e2.rotation, _s.scale = _e2.scale, _s.spatialReference = _o.spatialReference, this._update();
      }
    }
  }]);

  return h;
}(n);

t([s()], h.prototype, "paddedViewState", void 0), t([s({
  type: c
})], h.prototype, "padding", null), t([s()], h.prototype, "viewpoint", null), h = t([o("esri.views.2d.PaddedViewState")], h);
var m = h;
export { m as default };